import React from 'react';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import _ from 'lodash';
import moment from 'moment';
import {Grid, Icon} from 'semantic-ui-react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter} from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import IconNavigateBefore from 'material-ui/svg-icons/image/navigate-before';
import IconNavigateNext from 'material-ui/svg-icons/image/navigate-next';
import {getCheckouts, getShopifyAppConnection} from './actions';
import Tab from '../../components/tab';
import CheckoutsEmptyState from '../../components/empty-states/checkouts_empty_state';
import Loading from '../../components/loading';
import GA from '../../helpers/ga';
// import SendButton from './components/send-button';

const PAGE_VIEW_NAME = '/dashboard/checkouts';
const DEFAULT_STATE = {
	page: 1,
	limit: 10
};
const TD_STYLE = {
	paddingLeft: '8px',
	paddingRight: '8px'
};

export class CheckoutsListPage extends React.Component {
	constructor(props) {
		super(props);
		props.getShopifyAppConnection();
		this.state = {...DEFAULT_STATE};
	}

	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillReceiveProps (nextProps) {
		// Get shopify app connection
		if (_.isNil(nextProps.appConnection)) {
			nextProps.getShopifyAppConnection();
			return;
		}
		// Get checkouts
		if (!_.isEqual(nextProps.appConnection, this.props.appConnection)) {
			const appConnection = nextProps.appConnection;
			nextProps.getCheckouts(appConnection._id, 1, 10);
			return;
		}
	}

	getEmptyState (checkouts) {
		if (_.isNil(checkouts)) {
			return (<Loading />);
		}
		if (checkouts.length === 0) {
			return (<CheckoutsEmptyState />);
		}
		return (<div />);
	}

	render () {
		const paneHeight = this.props.containerHeight - 70;
		const emptyState = this.getEmptyState(this.props.checkouts);

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='Abandoned Checkouts'
				subHeaderText='A list of abandoned checkouts in your store'
			>
				<Grid textAlign='center'>
					<Grid.Row>
						{ this.generateTable(this, this.props.checkouts) }
						{ emptyState }
					</Grid.Row>
				</Grid>
				{/* <CheckoutInfoModal ref='checkoutInfoModal' /> */}
			</Tab.Pane>
		);
	}

	generateTableHeader() {
		return (
			<TableHeader
				displaySelectAll={false}
				adjustForCheckbox={false}
			>
				<TableRow>
					<TableHeaderColumn style={TD_STYLE} colSpan={2}>Checkout</TableHeaderColumn>
					<TableHeaderColumn style={TD_STYLE} colSpan={2}>Date</TableHeaderColumn>
					<TableHeaderColumn style={TD_STYLE} colSpan={4}>Placed by</TableHeaderColumn>
					<TableHeaderColumn style={TD_STYLE} colSpan={2}>Email Sent</TableHeaderColumn>
					<TableHeaderColumn style={TD_STYLE} colSpan={2}>Email Pending</TableHeaderColumn>
					<TableHeaderColumn style={TD_STYLE} colSpan={2}>Recovered?</TableHeaderColumn>
					<TableHeaderColumn style={TD_STYLE} colSpan={2}>Total</TableHeaderColumn>
					{/* <TableHeaderColumn style={TD_STYLE} colSpan={2}></TableHeaderColumn> */}
				</TableRow>
			</TableHeader>
		);
	}

	generateTableBody(ctx, checkouts) {
		const tableRows = _.map(checkouts, function(checkout) {
			return ctx.generateTableRow(ctx, checkout);
		});
		return(
			<TableBody
				displayRowCheckbox={ false }
				showRowHover={ false }>
				{ tableRows }
			</TableBody>
		);
	}

	generateTableRow(ctx, checkout) {
		const id = _.get(checkout, 'name', '');
		const createdAt = _.get(checkout, 'created_at', '');
		let formattedCreatedAt = '-';
		if (createdAt !== '') {
			formattedCreatedAt = moment(createdAt).format('MMM DD, H:mma');
		}
		const placedBy = _.get(checkout, 'email') || _.get(checkout, 'phone');
		const emailSent = _.get(checkout, 'notification.email.count_sent', 0);
		const emailPending = _.get(checkout, 'notification.email.count_pending', 0);
		const completedAt = _.get(checkout, 'completed_at');
		const recoveryStatus = _.isNil(completedAt) ? <Icon name='remove circle' size='large' style={{color: '#C0392B'}}/>: <Icon name='check circle' size='large' style={{color: '#27AE60'}}/>;
		const totalPrice = _.get(checkout, 'total_price', '0');
		// const sendButton = (<SendButton
		// 	checkout={checkout}
		// 	onComplete={ ctx.onCompleteSendButtonOperation }
		// />);
		return (
			<TableRow key={ checkout.token }>
				<TableRowColumn colSpan={2} style={{color: '#007EC0', ...TD_STYLE}}>{ id }</TableRowColumn>
				<TableRowColumn style={TD_STYLE} colSpan={2}>{ formattedCreatedAt }</TableRowColumn>
				<TableRowColumn style={TD_STYLE} colSpan={4}>{ placedBy }</TableRowColumn>
				<TableRowColumn style={TD_STYLE} colSpan={2}>{ emailSent }</TableRowColumn>
				<TableRowColumn style={TD_STYLE} colSpan={2}>{ emailPending }</TableRowColumn>
				<TableRowColumn style={TD_STYLE} colSpan={2}>{ recoveryStatus }</TableRowColumn>
				<TableRowColumn style={TD_STYLE} colSpan={2}>{ totalPrice }</TableRowColumn>
				{/* <TableRowColumn style={TD_STYLE} colSpan={2}>{ sendButton }</TableRowColumn> */}
			</TableRow>
		);
	}

	onCompleteSendButtonOperation(checkout) {
		console.log('onCompleteSendButtonOperation');
	}

	generateTableFooter(ctx) {
		const checkouts = ctx.props.checkouts;
		const visible = (_.isNil(checkouts)|| checkouts.length === 0);

		const limit = ctx.state.limit;
		const page = ctx.state.page;
		const count = ctx.props.count;
		const startingRowCount = (page - 1) * limit + 1;
		const maxEndingRowCount = (page) * limit;
		const endingRowCount = (page * limit > count)? count : maxEndingRowCount;
		const pagingString = startingRowCount + '-' + endingRowCount + ' of ' + count;
		const pagingButtons = ctx.generateTableFooterPageButtons(ctx);
		return (
			<TableFooter
				adjustForCheckbox={false}
			>
				<TableRow>
					<TableRowColumn colSpan='5'>
						<p style={{marginBottom: '15px'}} hidden={visible}>
							{ pagingString }
						</p>
					</TableRowColumn>
					<TableRowColumn colSpan='5' style={{textAlign: 'right'}} hidden={visible}>
						{ pagingButtons }
					</TableRowColumn>
				</TableRow>
			</TableFooter>
		);
	}

	generateTableFooterPageButtons(ctx) {
		const limit = ctx.state.limit;
		const page = ctx.state.page;
		const count = ctx.props.count;
		const isFirstPage = (ctx.state.page === 1);
		const isLastPage = (page * limit > count);
		return (
			<div>
				<IconButton
					disabled={isFirstPage}
					onClick={ ctx.moveToPreviousPage }>
					<IconNavigateBefore />
				</IconButton>
				<IconButton
					disabled={isLastPage}
					onClick={ ctx.moveToNextPage }>
					<IconNavigateNext />
				</IconButton>
			</div>
		);
	}

	moveToPreviousPage = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'PreviousPageButton', 1);
		this.setState({
			page: this.state.page - 1
		});
		this.props.getCheckouts(this.props.appConnection._id, this.state.page-1, this.state.limit);
	}

	moveToNextPage = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'NextPageButton', 1);
		this.setState({
			page: this.state.page + 1
		});
		this.props.getCheckouts(this.props.appConnection._id, this.state.page+1, this.state.limit);
	}

	handleRowSelection = (selectedRows) => {
		if (selectedRows && selectedRows.length > 0) {
			// const i = selectedRows[0];
			// this.refs.checkoutInfoModal.openModal(this.props.checkouts[i]);
		}
	}

	generateTable(ctx, checkouts) {
		return (
			<Table
				selectable={ false }
				multiSelectable={ false }
				onRowSelection={ this.handleRowSelection }>
				{ ctx.generateTableHeader() }
				{ ctx.generateTableBody(ctx, checkouts) }
				{ ctx.generateTableFooter(ctx) }
			</Table>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		count: state.dashboardCheckoutsReducer.count,
		checkouts: state.dashboardCheckoutsReducer.checkouts,
		appConnection: state.dashboardCheckoutsReducer.appConnection
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		getShopifyAppConnection () {
			dispatch( getShopifyAppConnection() );
		},

		getCheckouts (appConnectionId, page, limit) {
			dispatch( getCheckouts(appConnectionId, page, limit) );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(CheckoutsListPage) );



// WEBPACK FOOTER //
// ./src/containers/dashboard-checkouts-page/checkouts-list-page.js